import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Observable, of, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { HelperService } from '../helper.service';
import { IBusinessDetail } from '../interface';
import { isNil } from '../utils';
import { IFilterParams } from './interface';



@Component({
  selector: 'app-class-search-result-new',
  templateUrl: './class-search-result-new.component.html',
  styleUrls: ['./class-search-result-new.component.scss']
})
export class ClassSearchResultNewComponent implements OnInit {

  destroy$ = new Subject<boolean>();

  businessDetails$: Observable<IBusinessDetail[]> = of([])

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
  ) { 
  }


  ngOnInit(): void {
    
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  applyFilters(filters: IFilterParams) {
    console.log(filters)
    const payload = { 
      serviceTypeID: filters.categoryId,
      lat: null,
      lang: null
    }

    if (filters.specialityId) payload['specialityID'] = filters.specialityId
    if (filters.mode) payload['mode'] = filters.mode
    if (filters.location) {
      payload['lat'] = filters.location.geometry.location.lat()
      payload['lang'] = filters.location.geometry.location.lng()
    }

    this.businessDetails$ = this.apiService.classSearchList(payload)
      .pipe(
        map((res: any) => res.data.classBusinessData.data.businessDetails as IBusinessDetail[])
      )
  }
}
